import React from "react";

const APPLE_LINK = 'https://apps.apple.com/gb/app/raffle-house/id6749267782';
const GOOGLE_LINK = 'https://play.google.com/store/apps/details?id=com.rafflehouse_app';

const GooglePlayStoreIconSVG = () => {
    const id = 'google_play_store_icon';
    return (<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${id})`}>
            <path d="M26.8841 12.3476C19.7813 8.37435 12.6794 4.39947 5.57841 0.422996C4.87648 -0.0405744 4.06887 -0.101324 3.37109 0.134855L21.234 17.9977L26.8841 12.3476Z" fill="#32BBFF" />
            <path d="M3.37279 0.134766C3.24201 0.179063 3.11474 0.2325 2.99303 0.297047C2.22248 0.713859 1.65625 1.51591 1.65625 2.53031V33.465C1.65625 34.4794 2.22241 35.2815 2.99303 35.6982C3.11497 35.7624 3.24181 35.8168 3.37237 35.8609L21.2357 17.9977L3.37279 0.134766Z" fill="#32BBFF" />
            <path d="M21.2344 18L3.37109 35.8632C4.06909 36.1012 4.8767 36.0451 5.57884 35.5748C15.6756 29.9209 22.3122 26.2094 26.5426 23.8504L26.8899 23.6555L21.2344 18Z" fill="#32BBFF" />
            <path d="M1.65625 18V33.4673C1.65625 34.4817 2.22241 35.2838 2.99303 35.7005C3.11497 35.7647 3.24181 35.8191 3.37237 35.8632L21.2357 18H1.65625Z" fill="#2C9FD9" />
            <path d="M5.57927 0.423837C4.74571 -0.126569 3.76274 -0.110889 2.99219 0.298048L20.9637 18.2696L26.8849 12.3485C19.7821 8.37517 12.6803 4.40029 5.57927 0.423837Z" fill="#29CC5E" />
            <path d="M20.9639 17.7305L2.99219 35.702C3.76281 36.1109 4.74571 36.1345 5.57927 35.5762C15.676 29.9224 22.3127 26.2109 26.5431 23.8519L26.8903 23.657L20.9639 17.7305Z" fill="#D93F21" />
            <path d="M34.3424 17.9969C34.3424 17.1398 33.9099 16.2748 33.0527 15.7952C33.0527 15.7952 31.4496 14.9007 26.536 12.1523L20.6914 17.9969L26.5417 23.8473C31.4014 21.1187 33.0526 20.1986 33.0526 20.1986C33.9099 19.719 34.3424 18.854 34.3424 17.9969Z" fill="#FFD500" />
            <path d="M33.0527 20.2018C33.9099 19.7221 34.3424 18.8571 34.3424 18H20.6914L26.5417 23.8504C31.4015 21.1218 33.0527 20.2018 33.0527 20.2018Z" fill="#FFAA00" />
        </g>
        <defs>
            <clipPath id={id}>
                <rect width="36" height="36" fill="white" />
            </clipPath>
        </defs>
    </svg>
    )
}

const AppStoreIconSVG = () => {
    const id = `app_store_icon_${Math.random().toString(36).substr(2, 9)}`;
    return (<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#clip0_${id})`}>
            <path d="M28.728 0H7.272C3.2535 0 0 3.2535 0 7.272V28.7325C0 32.7465 3.2535 36 7.272 36H28.7325C32.7465 36 36.0045 32.7465 36.0045 28.728V7.272C36 3.2535 32.7465 0 28.728 0Z" fill={`url(#paint0_linear_${id})`} />
            <path d="M17.8469 8.27102L18.5759 7.01102C19.0259 6.22352 20.0294 5.95802 20.8169 6.40802C21.6044 6.85802 21.8699 7.86152 21.4199 8.64902L14.3954 20.808H19.4759C21.1229 20.808 22.0454 22.743 21.3299 24.084H6.43488C5.52588 24.084 4.79688 23.355 4.79688 22.446C4.79688 21.537 5.52588 20.808 6.43488 20.808H10.6109L15.9569 11.5425L14.2874 8.64452C13.8374 7.85702 14.1029 6.86252 14.8904 6.40352C15.6779 5.95352 16.6724 6.21902 17.1314 7.00652L17.8469 8.27102ZM11.5289 25.7715L9.95388 28.503C9.50388 29.2905 8.50038 29.556 7.71287 29.106C6.92537 28.656 6.65988 27.6525 7.10988 26.865L8.27988 24.84C9.60288 24.4305 10.6784 24.7455 11.5289 25.7715ZM25.0919 20.817H29.3534C30.2624 20.817 30.9914 21.546 30.9914 22.455C30.9914 23.364 30.2624 24.093 29.3534 24.093H26.9864L28.5839 26.865C29.0339 27.6525 28.7684 28.647 27.9809 29.106C27.1934 29.556 26.1989 29.2905 25.7399 28.503C23.0489 23.8365 21.0284 20.3445 19.6874 18.018C18.3149 15.651 19.2959 13.275 20.2634 12.4695C21.3389 14.3145 22.9454 17.1 25.0919 20.817Z" fill="white" />
        </g>
        <defs>
            <linearGradient id={`paint0_linear_${id}`} x1="18.0022" y1="0" x2="18.0022" y2="36" gradientUnits="userSpaceOnUse">
                <stop stopColor="#18BFFB" />
                <stop offset="1" stopColor="#2072F3" />
            </linearGradient>
            <clipPath id={`clip0_${id}`}>
                <rect width="36" height="36" fill="white" />
            </clipPath>
        </defs>
    </svg>
    )
}

export const MobileAppLinkAppStoreButton = () => {
    return (
        <a href={APPLE_LINK} className="mobile-app-link-button" target="_blank" rel="noopener noreferrer" >
            <div className="mobile-app-link-button-icon">
                <AppStoreIconSVG />
            </div>
            <div className="mobile-app-link-button-text">
                <span>Download on the</span>
                <span>App Store</span>
            </div>
        </a>
    );
}

export const MobileAppLinkGooglePlayButton = () => {
    return (
        <a href={GOOGLE_LINK} className="mobile-app-link-button" target="_blank" rel="noopener noreferrer" >
            <div className="mobile-app-link-button-icon">
                <GooglePlayStoreIconSVG />
            </div>
            <div className="mobile-app-link-button-text">
                <span>Download on the</span>
                <span>Google Play</span>
            </div>
        </a>
    );
}
